<template>
  <v-data-table
    :headers="headers"
    :items="SelectedImport.file_contents"
    :items-per-page="itemsPerPage"
    fixed-header
    hide-default-footer
    :height="`${tableHeight}px`"
  >
    <template v-slot:top>
      <v-toolbar flat extended class="pt-3" extension-height="24">
        <v-list>
          <v-list-item two-line class="pl-0">
            <v-list-item-content>
              <v-list-item-title class="headline mb-1">{{ SelectedImport.referrer.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ SelectedImport.file_name }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-spacer></v-spacer>
        <v-list class="text-right">
          <v-list-item>
            <v-list-item-subtitle>
              {{ SelectedImport.created_at | moment('DD/MM/YYYY HH:mm') }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item class="pt-0">
            <v-chip class="mr-2" color="success" text-color="white">
              <v-avatar left class="success darken-4">
                {{ SelectedImport.successful }}
              </v-avatar>
              Successful
            </v-chip>
            <v-chip class="mr-2" color="warning" text-color="white">
              <v-avatar left class="warning darken-4">
                {{ SelectedImport.duplicates }}
              </v-avatar>
              Duplicates
            </v-chip>
            <v-chip class="mr-2" color="error" text-color="white">
              <v-avatar left class="error darken-4">
                {{ SelectedImport.failed }}
              </v-avatar>
              Failed
            </v-chip>
            <v-chip color="info" text-color="white">
              <v-avatar left class="info darken-4">
                {{ SelectedImport.total_records }}
              </v-avatar>
              Total
            </v-chip>
          </v-list-item>
        </v-list>
      </v-toolbar>
    </template>
    <template v-slot:item.id="{ item }">
      <v-icon color="success" v-if="typeof item.id !== 'undefined'">fad fa-fw fa-check-circle</v-icon>
      <v-btn icon v-else @click="importReferral(item)">
        <v-icon color="error">fad fa-fw fa-file-plus</v-icon>
      </v-btn>
    </template>
    <template v-slot:item.requested_amount="{ item }">{{ item.requested_amount | currency }}</template>
  </v-data-table>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'BankImportFile',
  props: {
    referralDetails: {
      type: Object,
      default: null
    },
    showReferralCreate: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    headers: [
      { text: 'Company Name', value: 'company_name', width: '28%' },
      { text: 'First Name', value: 'first_name', width: '10%' },
      { text: 'Last Name', value: 'last_name', width: '10%' },
      { text: 'Email', value: 'email', width: '30%' },
      { text: 'Phone', value: 'phone', width: '10%' },
      { text: 'Requested', value: 'requested_amount', align: 'end', width: '10%' },
      { text: '', value: 'id', align: 'center', width: '2%' }
    ],
    itemsPerPage: 200
  }),
  computed: {
    ...mapGetters(['SelectedImport']),
    tableHeight() {
      return window.innerHeight - 170;
    }
  },
  methods: {
    ...mapActions(['selectBankImportFile']),
    importReferral(referral) {
      this.$emit('update:referralDetails', {
        ...referral,
        referrer: this.SelectedImport.referrer,
        import_id: this.SelectedImport.id
      });
      this.$emit('update:showReferralCreate', true);
    }
  },
  watch: {
    showReferralCreate: function() {
      this.selectBankImportFile(this.SelectedImport.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.calc-height {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}
</style>
